import { render, staticRenderFns } from "./InclusaoOcorrenciaInativarForm.vue?vue&type=template&id=510b31aa"
import script from "./InclusaoOcorrenciaInativarForm.vue?vue&type=script&lang=js"
export * from "./InclusaoOcorrenciaInativarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports